<template>
  <div class="associatedDevice">
    <div class="table-search">
      <a-form layout="inline">
        <a-row :gutter="12" class="searchRow">
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="请输入设备名称" v-model="searchModel.name" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="请输入设备编号" v-model="searchModel.number" />
          </a-col>
          <a-col :md="16" :sm="24" class="searchColBtn">
            <span class="table-page-search-submitButtons">
              <a-button class="btn" type="primary" @click="search">查询</a-button>
              <a-button class="btn btnMarginLeft_12" type="primary" @click="relate">关联</a-button>
              <a-button class="btn btnMarginLeft_12" @click="remove">移除</a-button>
              <a-button class="btn btnMarginLeft_12" @click="clearSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      bordered
      :pagination="pagination"
      :columns="tableData.columns"
      :rowKey="(record) => record.id"
      :dataSource="tableData.data"
      :loading="tableData.loading"
      :row-selection="rowSelection"
      @change="handleTableChange"
    >
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click.stop="() => handleDetail(record)">详情</a>
      </template>
    </a-table>

    <relation-modal ref="relationModal" @refreshTable="initTableData"></relation-modal>
  </div>
</template>

<script>
import { getAssociatedDeviceData } from '@/api/sparePartsManagement'
import relationModal from './relationModal.vue'
export default {
  components: { relationModal },
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initTableData()
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      searchModel: {},
      tableData: {
        data: [],
        columns: [
          {
            title: '设备名称',
            dataIndex: 'a',
          },
          {
            title: '设备编号',
            dataIndex: 'b',
          },
          {
            title: '设备类别',
            dataIndex: 'c',
            width: 140
          },
          {
            title: '规格型号',
            dataIndex: 'd',
            width: 140
          },
          {
            title: '归口部门',
            dataIndex: 'e',
            width: 180
          },
          {
            title: '使用部门',
            dataIndex: 'f',
            width: 180
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            width: 120
          }
        ],
        loading: false,
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      selectedRows: [],
      rowSelection: {
        columnWidth: 40,
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
    }
  },
  methods: {
    initTableData () {
      this.selectedRows = []
      this.rowSelection.selectedRowKeys = []
      const { current, pageSize } = this.pagination
      const params = {
        pageNum: current,
        pageSize,
        id: this.model.id
      }
      this.tableData.loading = true
      getAssociatedDeviceData(params).then(res => {
        this.tableData.loading = false
        if (res && res.status === 0) {
          // this.tableData.data = res.data.list
          // this.pagination.total = res.data.total
          let i = 9999
          while (i--) {
            this.tableData.data.push({ id: i, a: 'xxx', b: 'xxx', c: 'xxx', d: 'xxx', e: 'xxx', f: 'xxx' })
          }
          this.pagination.total = 9999
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(() => {
        this.tableData.loading = false
      })
    },
    handleTableChange (pagination) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.initTableData()
    },
    search () {
      const model = { ...this.searchModel }
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.number) {
        model.number = model.number.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.pagination.current = 1
      this.initTableData()
    },
    clearSearch () {
      this.searchModel = {}
      this.pagination.current = 1
      this.initTableData()
    },

    clear () {
      this.tableData.data = []
      this.pagination = {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      }
    },
    handleDetail () {},

    // 关联
    relate () {
      this.$refs.relationModal.setModel(this.model)
      this.$refs.relationModal.open(true)
    },
    // 移除
    remove () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请勾选要移除关联的设备')
        return
      }
      const params = {
        ids: this.rowSelection.selectedRowKeys
      }
      // 调接口移除
      // 后调接口刷新
      // this.initTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.associatedDevice{
  margin-left: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  // margin-bottom: 10px;
  .table-search{
    margin: 10px;
    .searchColBtn {
      // text-align: right;
      .btn {
        margin-right: 10px;
      }
    }
  }
  /deep/.ant-table{
    .ant-table-thead{
      > tr{
        > th{
          background: rgba(8,64,159,0.1);
        }
      }
    }
    .ant-table-row-expand-icon {
      margin-right: 0;
    }
  }
  /deep/.ant-table-bordered{
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td{
      border-color: #DDDDDD;
    }
    .ant-table-header > table,
    .ant-table-body > table,
    .ant-table-fixed-left table,
    .ant-table-fixed-right table{
      border-color: #DDDDDD;
    }
  }
}
</style>